import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { T } from "../constants";
import { cx } from "../styles";

/* ---------- Status tag ---------- */

const TONE = {
  ok: { color: T.successText, bg: T.successTint, bd: "rgba(62,172,77,0.35)" },
  bad: { color: T.danger, bg: T.dangerTint, bd: "rgba(255,59,48,0.35)" },
  warn: { color: T.warningFg, bg: T.warningTint, bd: "rgba(255,195,0,0.45)" },
  info: { color: T.primary, bg: T.primaryTint, bd: "rgba(49,39,184,0.30)" },
  muted: { color: T.mutedFg, bg: T.surface, bd: T.border },
};

const useTag = makeStyles({
  tag: {
    display: "inline-flex",
    alignItems: "center",
    borderRadius: 6,
    padding: "2px 8px",
    fontWeight: 600,
    border: ({ c }) => `1px solid ${c.bd}`,
    background: ({ c }) => c.bg,
    color: ({ c }) => c.color,
    fontSize: ({ size }) => size,
    textTransform: ({ upper }) => (upper ? "uppercase" : "none"),
  },
});

export default function Tag({ children, tone = "muted", size = 11, upper = false, className }) {
  const c = TONE[tone] || TONE.muted;
  const cls = useTag({ c, size, upper });
  return <span className={cx(cls.tag, className)}>{children}</span>;
}
